(function($, undefined) {
	
	'use strict';
	var historyLevelTabs;
	var historyLevelTabSelector = '.history-activity-level-tab';
	
	var init = function () {
		historyLevelTabs = $(historyLevelTabSelector);
		
		historyLevelTabs.on('click', switchHistoryLevelTab);
	};
	
	
	var switchHistoryLevelTab = function() {
		var tab = $(this);
		var ctn = tab.closest('.history-activity-list-item-content');
		var level = tab.text().replace('niveau ', '');
		
		if (!tab.hasClass('active')) {
			ctn.find('.exercises-list.active').removeClass('active');
			ctn.find('.exercises-list').filter('[data-level=' + level + ']').addClass('active');
			
			ctn.find(historyLevelTabSelector).filter('.active').removeClass('active');
			tab.addClass('active');
		}
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
